export class ConfigTranslation {
  public instructions: string;
  public instructions_External: string;
  public placeholder: string;
  public title: string;

  constructor() {
    this.instructions = '';
    this.instructions_External = '';
    this.placeholder = '';
    this.title = '';
  }
}

export class GlobalizationConfig {
  public 'en-US': ConfigTranslation;
  public 'es-ES': ConfigTranslation;
  public 'pt-BR': ConfigTranslation;

  constructor() {
    this['en-US'] = new ConfigTranslation();
    this['es-ES'] = new ConfigTranslation();
    this['pt-BR'] = new ConfigTranslation();
  }
}
